const MAX_PILL_TABS = 7;

export default function AdminFilterTabs({ tabs, activeKey, onChange, extra, label = 'Filter' }) {
  const useDropdown = tabs.length > MAX_PILL_TABS;

  if (useDropdown) {
    return (
      <div className="admin-filter-tabs-wrap">
        <div className="admin-filter-select-wrap">
          <label className="admin-filter-select-label" htmlFor="admin-category-filter">
            {label}
          </label>
          <select
            id="admin-category-filter"
            className="admin-filter-select"
            value={activeKey}
            onChange={(e) => onChange(e.target.value)}
          >
            {tabs.map((tab) => (
              <option key={tab.key} value={tab.key}>
                {tab.label}
                {typeof tab.count === 'number' ? ` (${tab.count})` : ''}
              </option>
            ))}
          </select>
        </div>
        {extra ? <div className="admin-filter-tabs__extra">{extra}</div> : null}
      </div>
    );
  }

  return (
    <div className="admin-filter-tabs-wrap">
      <div className="admin-filter-tabs" role="tablist" aria-label={label}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeKey === tab.key}
            className={
              activeKey === tab.key ? 'admin-filter-tab admin-filter-tab--active' : 'admin-filter-tab'
            }
            onClick={() => onChange(tab.key)}
          >
            {tab.label}
            {typeof tab.count === 'number' ? (
              <span className="admin-filter-tab__count">{tab.count}</span>
            ) : null}
          </button>
        ))}
      </div>
      {extra ? <div className="admin-filter-tabs__extra">{extra}</div> : null}
    </div>
  );
}
